import {Reducer} from 'redux';
import IUIStore, {UIStoreActionType, UIStoreState, UIStoreTypes} from './types';

class UIStore implements IUIStore {
	// This just allows us to use this.types.whatevertype instead of using strings
	readonly types = UIStoreTypes;

	// Here we define the action creators
	readonly actions = {
		setLeftRail: newstate => ({type: this.types.SET_LEFT_RAIL, payload: newstate}),
	};

	// This is where we keep our initial state
	readonly state = {
		leftRailOpen: true,
	};

	// Here we define the reducer
	readonly reducer: Reducer<UIStoreState, UIStoreActionType> = (state = this.state, action) => {
		switch (action.type) {
			case this.types.SET_LEFT_RAIL:
				return {
					...state,
					leftRailOpen: action.payload,
				};
			default:
				return state;
		}
	};

	// Here we wrap the dispatch methods to make them easier to use
	readonly setLeftRail = (newstate: boolean) => dispatch => dispatch(this.actions.setLeftRail(newstate));
}

export default UIStore;
